import React from 'react';
import { SpheraModal, SpheraCheckbox, SpheraSpinner } from '@sphera-cloud/component-ui-reactjs';
import TokenInput from 'react-customize-token-input';

export function EditTagsModal(props) {
    const loadingPanel = (
        <div className="k-loading-mask">
            <span className="k-loading-text">{props.localizations.Loading}</span>
            <SpheraSpinner version={1} color="dark-1" />
        </div>
    );

    return (
        <div>
            {props.showEditTags && (
                <SpheraModal className="AssignFilterToGroup" title={props.isDelete ? props.localizations.DeleteTags : props.localizations.AddTags} width={400} height={300}
                    onClose={props.toggleEditTags}
                    onCancel={props.toggleEditTags}
                    cancelText={props.localizations.Cancel}
                    actionText={props.localizations.Save}
                    onAction={props.submitEditTags}
                >
                    <div className="AssignFilterToGroupDiv" >
                        {!props.isDelete ? (
                            <TokenInput tokenValues={props.TagsValue} onTokenValuesChange={props.changeTagsValue} separators={['\n']} style={{ height: "80px" }} />
                        ) : (<>
                                <div><b>{props.localizations.Tags}:</b></div>
                                {props.tagsOptions.map((x, index) => {
                                    return <SpheraCheckbox label={x} key={index} primary={true} value={props.TagsValue.indexOf(x) > -1} onChange={props.changeTagsValue} />;
                                })}
                        </>)}
                    </div>
                    {props.modalPending && loadingPanel}
                </SpheraModal>
            )}
        </div>
    );
}